export const ProjectData =
  [
    {
      "title": "KleinSoft One — Business Operations Platform",
      "type": "Web App / SaaS",
      "description": "Full-stack business operations platform for small businesses and sole traders. Unifies client management, invoicing, payments (with live Stripe data), expenses, tasks, and services into a single authenticated web app — eliminating fragmented tools and billing workflows.",
      "technologies": [
        "Next.js 15",
        "TypeScript",
        "Firebase",
        "Stripe API",
        "Tailwind CSS",
        "Radix UI",
        "Zustand",
        "React Hook Form",
        "Zod"
      ],
      "features": [
        "Live Stripe integration: creating a client auto-provisions a Stripe Customer; defining a service creates a Stripe Product/Price via Firebase Cloud Functions.",
        "Unified Payments view merging live Stripe invoice data with legacy Firestore invoices, with filter by source and status.",
        "Real-time financial dashboard (paid, outstanding, overdue) pulling from both Stripe API and Firestore.",
        "PDF invoice generation with ABN, GST toggle, and bank details via @react-pdf/renderer.",
        "Task management in three views: Table, drag-and-drop Kanban board, and drag-and-drop Calendar (week/month).",
        "Full onboarding flow capturing industry and business type, plus a Stripe Migration tool to bulk-migrate existing clients and services."
      ],
      "github": "",
      "images": ["/images/kleinsoft-one-1.png"]
    },
    {
      "title": "Sacramental Enrolment System",
      "type": "Web App",
      "description": "Production cloud-hosted enrolment management system actively used by parish staff and parents, processing 295+ enrolments. Responsible for ongoing development, support, and operational management.",
      "technologies": [
        "React",
        "Firebase Firestore",
        "Firebase Authentication",
        "Firebase Functions",
        "Gmail API",
        "Google Sheets API"
      ],
      "features": [
        "Production system processing 295+ enrolments",
        "Root cause analysis using system logs and usage data",
        "Authentication and role-based access controls using Firebase",
        "Enforced security rules for structured Firestore databases",
        "Communicated technical issues clearly to non-technical stakeholders",
        "Documented incidents and system changes through JIRA and Git"
      ],

      "github": "",
      "images": [
        "/images/sacrament-system-image1.png",
        "/images/sacrament-system-image2.png"
      ]
    },
    {
      "title": "KleinSoft Ops — Field Operations App",
      "type": "Mobile App",
      "description": "Purpose-built Android app for independent IT support technicians. Handles the full job lifecycle on a single device — from arrival to payment collection.",
      "technologies": ["Flutter", "Dart", "Firebase Firestore", "Firebase Cloud Functions", "Firebase App Check", "Stripe"],
      "features": [
        "Live visit timer with start/pause/stop that survives app backgrounding and device restarts.",
        "Automated billing calculations: $60 flat for the first hour, then $15 per additional 15-minute increment.",
        "Flexible payment collection: Stripe Tap to Pay, email invoice, or SMS/WhatsApp payment link.",
        "Offline-first architecture: job data queued locally and synced automatically on reconnection."
      ],
      "github": "",
      "images": ["/images/kleinsoft-ops-1.png", "/images/kleinsoft-ops-2.png"]
    },
    {
      "title": "Mass Slide Builder",
      "type": "Windows Desktop App",
      "description": "Python/Tkinter desktop tool built to automate recurring slide preparation for weekly services. Reduced repetitive manual work, improved consistency, and was documented and handed over for ongoing staff use in a live operational environment.",
      "technologies": ["Python", "Tkinter", "python-pptx", "python-docx", "PyInstaller", "Inno Setup"],
      "features": [
        "Automated recurring slide generation from structured service content",
        "Semi-automated hymn reporting integration",
        "Produced user documentation and delivered hands-on training",
        "Packaged as a Windows installer (.exe) for straightforward staff use"
      ],
      "github": "",
      "images": ["/images/mass-slide-builder-image1.png", "/images/mass-slide-builder-image2.png"]
    }
  ] 
